'use strict';
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

const _RollbackOutlined = _interopRequireDefault(require('./lib/icons/RollbackOutlined'));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

const _default = _RollbackOutlined;
exports.default = _default;
module.exports = _default;